import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

// Vue.http.interceptors.push(AuthInterceptor);
// Vue.http.interceptors.push(AuthErrorInterceptor);